import { Clock, ChevronRight, BookOpen } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import SEOMeta from "@/components/SEOMeta";
import ExitIntent from "@/components/ExitIntent";
import { ARTICLES, CATEGORIES } from "@/data/learnArticles";

export default function Learn() {
  const grouped = {};
  ARTICLES.forEach((a) => {
    grouped[a.category] = grouped[a.category] || [];
    grouped[a.category].push(a);
  });

  return (
    <div className="min-h-screen bg-[var(--bg-page)] text-white">
      <SEOMeta
        title="Learn Algo Trading — Guides for Indian Traders"
        description="Free guides on algo trading, options strategies, IV Rank, PCR, bracket orders, and automated trading for Indian retail traders."
        url="/learn"
        keywords="algo trading guide india, options trading explained india, learn automated trading india"
      />
      <ExitIntent />

      <PublicNav />

      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="overline txt-accent mb-3">Knowledge Base</div>
        <h1 className="font-section text-3xl text-white mb-4">Learn Algo Trading</h1>
        <p className="txt-secondary text-base mb-12 max-w-2xl">
          Free guides for Indian retail traders — from connecting your broker to reading options chains
          and building automated strategies. No fluff, no paid courses.
        </p>

        {Object.entries(grouped).map(([cat, articles]) => (
          <div key={cat} className="mb-12">
            <div className="overline text-xs mb-4 pb-2 border-b border-[var(--border)]">
              {CATEGORIES[cat] || cat}
            </div>
            <div className="space-y-1">
              {articles.map((a) => (
                <Link
                  key={a.slug}
                  to={`/learn/${a.slug}`}
                  className="flex items-center justify-between group py-3 px-4 hover:bg-[var(--bg-surface)] border border-transparent hover:border-[var(--border)] transition-all"
                >
                  <div className="flex items-start gap-3">
                    <BookOpen className="w-4 h-4 txt-muted mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="text-sm text-white group-hover:txt-accent transition-colors font-section">
                        {a.title}
                      </div>
                      <div className="text-xs txt-muted mt-0.5 line-clamp-1">{a.description}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0 ml-4">
                    <span className="text-xs txt-muted flex items-center gap-1">
                      <Clock className="w-3 h-3" />{a.readTime} min
                    </span>
                    <ChevronRight className="w-4 h-4 txt-muted group-hover:text-white transition-colors" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}

        {/* CTA */}
        <div className="mt-16 panel p-8 text-center border-[var(--accent)]/20">
          <div className="font-section text-xl text-white mb-2">Ready to put this into practice?</div>
          <p className="txt-secondary text-sm mb-6">
            AlgoForge gives you ₹10,00,000 virtual capital, a visual strategy builder, and live options analytics — free.
          </p>
          <Link
            to="/register"
            className="inline-block px-8 py-3 bg-[var(--accent)] hover:bg-indigo-500 text-white font-section tracking-wider text-sm transition-colors"
          >
            START FREE — NO CREDIT CARD
          </Link>
        </div>
      </div>
    </div>
  );
}
